module.exports = __webpack_public_path__ + "img/user_item_b.ff91dcad.svg";